export default {
  getOpenRequest: (state) => state.openRequest,
  getCloseRequest: (state) => state.closeRequest,
  getCloseCall: (state) => state.closeCall,
  getOpenCall: (state) => state.openCall,
  getOpenInvoice: (state) => state.openInvoice,
  getPaidInvoice: (state) => state.paidInvoice,
  getCaseNum: (state) => state.hdcase,
  getTodayJobs: (state) => state.todayJobs,
  getUpcomJobs: (state) => state.upcomJobs,
  getEquips: (state) => state.equips,
  getEquipHeader: (state) => state.equipHeader,
  getEquipDetail: (state) => state.equipDetail,
  getJobsList: (state) => state.jobsList,
  getInvoiceHeader: (state) => state.invoiceHeader,
  getInvoiceDtl: (state) => state.invoiceDtl,
  getHomeData: (state) => state.home,
  getContractHead: (state) => state.contractHead,
  getContractDtl: (state) => state.contractDtl,
  getContractRenewal: (state) => state.contractRenewal,
  getQuoteHead: (state) => state.quoteHead,
  getQuoteDtl: (state) => state.quoteDtl,
  getOrderHead: (state) => state.orderHead,
  getOrderDtl: (state) => state.orderDtl,
  getShipHead: (state) => state.shipHead,
  getShipDtl: (state) => state.shipDtl,
  getRmaHead: (state) => state.rmaHead,
  getRmaDtl: (state) => state.rmaDtl,
  getMemo: (state) => state.memo,
  getInventory: (state) => state.inventory,
  getProjectJobs: (state) => state.projectJobs,
  getProjectJobsDtls: (state) => state.projectJobsDtls,
  getIsDone: (state) => state.isDone,
  getJobListBoard: (state) => state.jobListBoard,
  technianList: (state) => state.technianList,
  getDriverList: (state) => state.driverList,
  getEquipList: (state) => state.equipList,
  getTransportPlans: (state) => state.transportPlans,
  getBookingPlans: (state) => state.bookingPlans,
};
